import Tarubhawana1 from "./Tarubhawana (1).webp";
import Tarubhawana2 from "./Tarubhawana (2).webp";
import Tarubhawana3 from "./Tarubhawana (3).webp";
import Tarubhawana4 from "./Tarubhawana (4).webp";

const tarubhawana = [Tarubhawana1, Tarubhawana2, Tarubhawana3, Tarubhawana4];

export default tarubhawana;
